/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import BasicCarousel from './components/BasicCarousel';

const App = () => {
	const [data, setData] = useState([]);

	const getdata = async () => {
		const sendData = {
			OrgId: Number("53"),
			UserId: Number("593"),
		}


		await fetch('https://n4nairmatrimonyapi.azurewebsites.net/api/Data/Latestusers', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(sendData)

		})
			.then(response => response.json())
			.then(
				data => {
					setData(data)
					/*console.log(data)*/
		
				})

	};
	

	useEffect(() => {
		getdata()

	}, [])
    return (
		<>
			
			<div className="content-agileits" id="about">
				<div className="welcome-w3">
					<div className="container">
						<h3 className="w3_tittle">About Us </h3>
						<div className="welcome-grids">
							<div className="col-md-5 wel-grid1">
								<div className="port-7 effect-2">
									<div className="image-box">
										<img src="images/bg-3.jpeg" alt="Image-2" />
									</div>

								</div>
							</div>
							<div className="col-md-7 wel-grid">
								<p>
									n4nairmatrimony.com is a complete wedding portal hosted by the Nair Service Society Delhi (Regd.) with a sole objective to provide a dedicated website for the Nair community to find their partners.

									Nairs who value tradition and customs are passionate about their roots.  n4nairmatrimony.com will help them to connect with a partner from their community irrespective of whether they are from the same city or across any part of the world.   The revenue generated through this site shall only be used for charitable, humanitarian, cultural or educational activities by the parent organization, which is registered under the Societies Registration Act of 1860.

									What is more, since its inception in 2010, n4nairmatrimony.com  is  providing the best quality of matrimonial services by expanding the opportunities available to meet the potential life partners and the services have already reached a level in the lives of thousands of people living across the globe.
								</p>


							</div>
							<div className="clearfix"></div>
						</div>
					</div>
				</div>
			</div>

			<div className="agile-serv">
				<div className="col-md-6 agileits-serv">
					<div className="left-w3l">
						<h4>Ideas About Your Wedding</h4>
						<h5>Have a DJ request box on your Sangeet</h5>
						<p>iTurn your coasters into 'DJ Request chits' that guests can scribble on. Drop them in a box for the DJ to listen to</p>
						<ul>
							<li><a href="#"><i className="glyphicon glyphicon-ok"></i>Best wedding Dress Collection Of New Year</a></li>
							<li><a href="#"><i className="glyphicon glyphicon-ok"></i>The Best wedding Songs</a></li>
							<li><a href="#"><i className="glyphicon glyphicon-ok"></i>Wedding Reception Setting.</a></li>
							<li><a href="#"><i className="glyphicon glyphicon-ok"></i>Create a Magnificent Mandap.</a></li>
							<li>    </li>
						</ul>
					</div>
				</div>
				<div className="col-md-6 right-w3l">
					<img style={{ maxHeight: '10%', maxWidth: '68%' }} src="/images/flower.jpg" alt="" />
				</div>
				<div className="clearfix"> </div>
			</div>
			<hr />

			<div className="team" id="planners">
				<div className="container">
					<h3 className="w3_tittle">Featured Profiles</h3>
					<div className="team-row-agileinfo">
						{data.map((item, index) => <div className="col-md-3 col-sm-6 col-xs-6 team-grids" key={index }>
							<div className="thumbnail team-agileits">
								<img src={"https://n4nairmatrimonyapi.azurewebsites.net" + item.image} style={{ height: "200px" }} alt="" />
								<div className="w3agile-caption">
									<div className="w3l-team-text">
										<h4>{item.organizationName}</h4>
										<h6>{item.work}</h6>
									</div>
								</div>
							</div>
						</div>)}
						<div className="clearfix"> </div>
					</div>
				</div>
			</div>

			<section id="pricing" className="pricing sections-bg">
				<div className="container" data-aos="fade-up">

					<div className="section-header">
						<h2 className="price">Pricing</h2>

					</div>

					<div className="row g-4 py-lg-5" data-aos="zoom-out" data-aos-delay="100">

						<div className="col-lg-4">
							<div className="pricing-item">
								<h3 className="money">Free Registration</h3>
								<div className="icon">
									<img src="images/star.gif" alt="free registration" height="100px" />
								</div>
								<h4 className="money-1"><sup>₹</sup>0<span> /3 month</span></h4>
								<ul>
									<li><i className="bi bi-check"></i> Limited Profile access</li>
									<li><i className="bi bi-check"></i> Profile Validity upto 3 Months </li>
									<li><i className="bi bi-check"></i> Upgrade to premium or platinum plan for more and more Profile access.</li>
								</ul>
								<div className="text-center"><a href="https://n4dashboard.azurewebsites.net/auth-register" className="buy-btn">Register Now</a></div>
							</div>
						</div>

						<div className="col-lg-4">
							<div className="pricing-item">
								<h3 className="money">Premium</h3>
								<div className="icon">
									<img src="images/globe.gif" alt="premium" height="100px" />
								</div>

								<h4 className="money-1"><sup>₹</sup>3000<span> /6 month</span></h4>
								<ul>
									<li><i className="bi bi-check"></i> Upto 100 profile access</li>
									<li><i className="bi bi-check"></i> Profile validity 6 months from the date of registration</li>
									<li>      </li>
									<li>      </li>

								</ul>
								<div className="text-center"><a href="#" className="buy-btn">Buy Now</a></div>
							</div>
						</div>

						<div className="col-lg-4">
							<div className="pricing-item">
								<h3 className="money">Platinum</h3>
								<div className="icon">
									<img src="images/party.gif" alt="platinum" height="100px" />
								</div>
								<h4 className="money-1"><sup>₹</sup>5000<span> /1 Year</span></h4>
								<ul>
									<li><i className="bi bi-check"></i> Unlimited Profile access</li>
									<li><i className="bi bi-check"></i> Profile validity 1 year from the date of registration.</li>
									<li>      </li>
									<li>      </li>

								</ul>
								<div className="text-center"><a href="#" className="buy-btn">Buy Now</a></div>
							</div>
						</div>

					</div>

				</div>
			</section>


			<div id="gallery" className="welcome gallery">
				<div className="container">
					<h3 className="w3_tittle">Our Gallery</h3>

					<div className="gallery-container-new">
						{/* Row 1 */}
						<div className="gallery-row">
							<div className="gallery-col gallery-col-large">
								<div className="gallery-card">
									<img src="images/nair.webp" alt="Nair Wedding Ceremony" />
								</div>
							</div>
							<div className="gallery-col gallery-col-large">
								<div className="gallery-card">
									<img src="images/pic13.jpeg" alt="Nair Wedding Ceremony" />
								</div>
							</div>

							{/*<div className="gallery-col gallery-col-small">*/}
							{/*	<div className="gallery-card">*/}
							{/*		<img src="images/bg-3.jpeg" alt="Wedding Moments" />*/}
							{/*		<div className="gallery-overlay">*/}
							{/*			<div className="gallery-text">*/}
							{/*				<h4>Special Moments</h4>*/}
							{/*			</div>*/}
							{/*		</div>*/}
							{/*	</div>*/}

							{/*	<div className="gallery-card">*/}
							{/*		<img src="images/flower.jpg" alt="Decoration" />*/}
							{/*		<div className="gallery-overlay">*/}
							{/*			<div className="gallery-text">*/}
							{/*				<h4>Decorations</h4>*/}
							{/*			</div>*/}
							{/*		</div>*/}
							{/*	</div>*/}
							{/*</div>*/}
						</div>

						{/* Row 2 */}
						<div className="gallery-row">
							<div className="gallery-col gallery-col-medium">
								<div className="gallery-card">
									<img src="images/pic10.1.jpg" alt="Reception" />
								</div>
							</div>

							<div className="gallery-col gallery-col-medium">
								<div className="gallery-card">
									<img src="images/new_image.jpeg" alt="Celebrations" />
								</div>
							</div>


							{/*<div className="gallery-col gallery-col-medium">*/}
							{/*	<div className="gallery-card">*/}
							{/*		<img src="images/bg-5.jpg" alt="Family Gathering" />*/}
							{/*		<div className="gallery-overlay">*/}
							{/*			<div className="gallery-text">*/}
							{/*				<h4>Family Together</h4>*/}
							{/*			</div>*/}
							{/*		</div>*/}
							{/*	</div>*/}
							{/*</div>*/}
						</div>

						{/* Row 3 */}
						{/*<div className="gallery-row">*/}
						{/*	<div className="gallery-col gallery-col-small">*/}
						{/*		<div className="gallery-card">*/}
						{/*			<img src="images/new_image.jpeg" alt="Couple" />*/}
						{/*		</div>*/}

						{/*		*/}{/*<div className="gallery-card">*/}
						{/*		*/}{/*	<img src="images/pic9.1.jpg" alt="Rituals" />*/}
						{/*		*/}{/*	<div className="gallery-overlay">*/}
						{/*		*/}{/*		<div className="gallery-text">*/}
						{/*		*/}{/*			<h4>Sacred Rituals</h4>*/}
						{/*		*/}{/*		</div>*/}
						{/*		*/}{/*	</div>*/}
						{/*		*/}{/*</div>*/}
						{/*	</div>*/}

						{/*	*/}{/*<div className="gallery-col gallery-col-large">*/}
						{/*	*/}{/*	<div className="gallery-card">*/}
						{/*	*/}{/*		<img src="images/bg-4.1.jpg" alt="Wedding Photography" />*/}
						{/*	*/}{/*		<div className="gallery-overlay">*/}
						{/*	*/}{/*			<div className="gallery-text">*/}
						{/*	*/}{/*				<h4>Memorable Photography</h4>*/}
						{/*	*/}{/*			</div>*/}
						{/*	*/}{/*		</div>*/}
						{/*	*/}{/*	</div>*/}
						{/*	*/}{/*</div>*/}
						{/*</div>*/}

						{/* Row 4 - All Equal */}
						{/*<div className="gallery-row gallery-row-equal">*/}
						{/*	<div className="gallery-col">*/}
						{/*		<div className="gallery-card">*/}
						{/*			<img src="images/nair.webp" alt="Venue" />*/}
						{/*		</div>*/}
						{/*	</div>*/}

						{/*	<div className="gallery-col">*/}
						{/*		<div className="gallery-card">*/}
						{/*			<img src="images/pic10.1.jpg" alt="Decoration Details" />*/}
						{/*		</div>*/}
						{/*	</div>*/}

						{/*	<div className="gallery-col">*/}
						{/*		<div className="gallery-card">*/}
						{/*			<img src="images/new_image.jpeg" alt="Festive Mood" />*/}
									
						{/*		</div>*/}
						{/*	</div>*/}

							
						{/*</div>*/}
					</div>
				</div>
			</div>
			<hr />
        </>
        )
}
export default App;